import { render } from "./RecommendedDonors.vue?vue&type=template&id=6c399f3c&scoped=true"
import script from "./RecommendedDonors.vue?vue&type=script&lang=ts"
export * from "./RecommendedDonors.vue?vue&type=script&lang=ts"

import "./RecommendedDonors.vue?vue&type=style&index=0&id=6c399f3c&scoped=true&lang=css"
import "./RecommendedDonors.vue?vue&type=style&index=1&id=6c399f3c&lang=css"
script.render = render
script.__scopeId = "data-v-6c399f3c"

export default script